import React, { useEffect, useState } from "react"
import { useNavigate, useParams } from 'react-router'
import { useTranslation } from 'react-i18next'

import { httpOk, GET } from "helpers/api"
import { formatMoney, formatDate } from 'helpers/helpers'

import ThermalPrint, { ThermalPrintButton, useThermalPrint } from 'pages/parts/ThermalPrint'

function Preview() {
	const { t } = useTranslation()
	const { id } = useParams()
	const navigate = useNavigate()

	const [data, setData] = useState({})
	const { printRef, handlePrint } = useThermalPrint()

	async function getData() {
		const response = await GET(`/documents-price/${id}`, {}, { loader: true })
		if (httpOk(response)) setData(response.data)
	}

	useEffect(() => {
		getData()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<div className="d-flex text-truncate">
					<h4 className="vertical-center">
						{t('price_change')}
					</h4>
					<div className="vertical-center mt-1">
						<i className="uil uil-angle-double-right fz-20"></i>
					</div>
					<div className="vertical-center mt-1">
						<h6>{t('preview')}</h6>
					</div>
				</div>

				<div className="vertical-center">
					<ThermalPrintButton onClick={handlePrint} />
				</div>
			</div>

			<div className="card mb-3">
				<div className="card-body">
					<h4 className="fw-600">{t('document_from')} {formatDate(data.created_at, 'dd.MM.yy HH:mm')}</h4>
					<div className="flex-column preview-info">
						<div className="d-flex gap-2">
							<div className="fw-600">{t('note')}:</div>
							<div>{data.note}</div>
						</div>
					</div>
				</div>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="table-responsive">
						<table className="table table-bordered">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '30%' }}>{t('name2')}</th>
									<th style={{ 'width': '15%' }} className="text-end">{t('sale_price')}</th>
									<th style={{ 'width': '15%' }} className="text-end">{t('new_sale_price')}</th>
									<th style={{ 'width': '40%' }}></th>
								</tr>
							</thead>
							<tbody>
								{data?.products?.map((item, index) => (
									<tr key={index}>
										<td className="text-center">{index + 1}</td>
										<td title={item.name}>{item.name}</td>
										<td className="text-end">{formatMoney(item.old_sale_price)}</td>
										<td className="text-end">{formatMoney(item.sale_price)}</td>
										<td></td>
									</tr>
								))}
							</tbody>
						</table>
					</div>

					<div className="d-flex justify-content-end mt-5">
						<button type="button" className="btn btn-warning btn-rounded btn-wide"
							onClick={() => navigate(-1)}>
							{t('cancel')}
						</button>
					</div>
				</div>
			</div >

			<ThermalPrint
				printRef={printRef}
				title={`${t('document_from')} ${formatDate(data.created_at, 'dd.MM.yy HH:mm')}`}
				info={[
					{ label: t('note'), value: data.note },
				]}
				columns={[
					{ label: t('name2'), width: '48%', numbered: true, render: (item) => item.name },
					{ label: t('sale_price'), width: '26%', align: 'end', render: (item) => formatMoney(item.old_sale_price) },
					{ label: t('new_sale_price'), width: '26%', align: 'end', render: (item) => formatMoney(item.sale_price) },
				]}
				rows={data?.products || []}
			/>
		</>
	)
}

export default Preview